import { signal } from '@preact/signals';

import type { Toast } from './toast.model';

class ToastService {
  toasts = signal<Toast[]>([]);

  success(header: string, body?: string, delay?: number, clickCallback?: () => void): void {
    header = this.capitalizeFirstLetter(header);
    body = this.capitalizeFirstLetter(body);
    const toast: Toast = {
      header,
      body,
      className: 'success',
      delay,
      clickCallback,
    };
    this.toasts.value = [...this.toasts.value, toast];

    setTimeout(() => {
      this.remove(toast);
    }, delay ?? 5000);
  }

  error(header: string, body?: string, delay?: number, clickCallback?: () => void): void {
    header = this.capitalizeFirstLetter(header);
    body = this.capitalizeFirstLetter(body);
    const toast: Toast = {
      header,
      body,
      className: 'error',
      delay,
      clickCallback,
    };
    this.toasts.value = [...this.toasts.value, toast];

    setTimeout(() => {
      this.remove(toast);
    }, delay ?? 5000);
  }

  warning(header: string, body?: string, delay?: number, clickCallback?: () => void): void {
    header = this.capitalizeFirstLetter(header);
    body = this.capitalizeFirstLetter(body);
    const toast: Toast = {
      header,
      body,
      className: 'warning',
      delay,
      clickCallback,
    };
    this.toasts.value = [...this.toasts.value, toast];

    setTimeout(() => {
      this.remove(toast);
    }, delay ?? 5000);
  }

  remove(toast: Toast): void {
    if (toast.hiding) return;
    // Play the exit animation before dropping the toast from the list.
    toast.hiding = true;
    this.toasts.value = [...this.toasts.value];
    setTimeout(() => {
      this.toasts.value = this.toasts.value.filter((t) => t !== toast);
    }, 250);
  }

  private capitalizeFirstLetter(str?: string): string {
    // @ts-ignore
    return str?.charAt(0).toUpperCase() + str?.slice(1) || '';
  }
}

export const toastService = new ToastService();
